export const environment = {
  production: false,
  APISETTINGS : 'https://digitalqamatrix-qa.unilever.com/qmapi/',
  tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  clientId: '0c4a8941-e08e-423a-9669-54683beee475',
  endpoints: 'https://digitalqamatrix-qa.unilever.com/',
  OAUTH_TOKEN_ENDPOINT : 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/oauth2/v2.0/token'
};
